import { usePathname, useRouter } from 'expo-router';
import { useFormContext } from 'react-hook-form';
import { Pressable } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Text from '@/components/Unistyles/Text';
import {
  resetWelcomeSetup,
  type WelcomeFormValues,
} from '@/layouts/Welcome/form';
import {
  isWelcomeSetupPathname,
  WELCOME_COMPLETION_ROUTE,
} from '@/layouts/Welcome/navigation';
import useJoinIntentStore from '@/stores/useJoinIntentStore';
import useOnboardingStore from '@/stores/useOnboardingStore';

export default function WelcomeSkipSetupButton() {
  const pathname = usePathname();
  const { dismissAll, replace } = useRouter();
  const { setValue } = useFormContext<WelcomeFormValues>();
  const resetOnboarding = useOnboardingStore((state) => state.reset);
  const clearJoinIntent = useJoinIntentStore((state) => state.clearJoinIntent);
  const joinResumePending = useJoinIntentStore(
    (state) => state.joinResumePending,
  );

  if (joinResumePending || !isWelcomeSetupPathname(pathname)) {
    return null;
  }

  const onPress = () => {
    clearJoinIntent();
    resetOnboarding();
    resetWelcomeSetup(setValue);
    dismissAll();
    replace(WELCOME_COMPLETION_ROUTE);
  };

  return (
    <Pressable
      hitSlop={20}
      onPress={onPress}
      style={({ pressed }) => styles.button(pressed)}
      testID="WelcomeSkipSetup"
    >
      <Text size="lg" variant="typographySecondary">
        Skip Setup
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create((theme) => ({
  button: (pressed: boolean) => ({
    alignItems: 'center',
    justifyContent: 'center',
    opacity: pressed ? 0.8 : 1,
    _web: {
      paddingHorizontal: theme.space('lg'),
      _hover: {
        opacity: 0.8,
      },
    },
  }),
}));
